import {navHeightItem} from "../../../../../../@signals";
import {dsColorNew} from "@palette";


export const MaximalLayoutNavVerticalItemStyles = (isActive, isSubItem, theme) => ({
    position: 'relative',
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    color: 'rgba(255,255,255,0.82)',
    borderRadius: theme.shape.borderRadius,
    height: navHeightItem.value,
    '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.06)',
        color: '#fff',
    },
    ...( isActive && {
        color: '#fff',
        ...( !isSubItem && {
            backgroundColor: dsColorNew.appBlue,
        }),
        '&:hover': {
            color: '#fff',
            backgroundColor: dsColorNew.appBlueHover,
        },
        i: {
            color: '#fff',
        }
    })
})

export const MaximalLayoutNavVerticalIconStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    minWidth: "auto",
    width: "24px",
    height: "24px",
    color: 'inherit'
}